
import { H6 } from "../../../AbstractElements";
import { Link } from "react-router-dom";
import { Href } from "../../../utils/Constant";
import { Badge, Button } from "reactstrap";
import { Edit } from "react-feather";
import { Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { updateUserByAdminAction } from "../../../Api/auth";
import { toast } from "react-toastify";

interface PatientsTableBodyProps {
  patients: any
  setPatients: (patients: any) => void

}

const PatientsTableBody: React.FC<PatientsTableBodyProps> = ({ patients = [], setPatients }) => {
  return (
    <Fragment>
      <tbody>
        {patients[0] ? patients.map((patient: any, i: any) => (
          <tr key={i}>
            <td>
              {i + 1}
            </td>
            <td>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 ms-2">
                  <Link to={Href}>
                    <H6>{patient.firstname}</H6>
                  </Link>
                </div>
              </div>
            </td>
            <td className="project-dot">
              <div className="d-flex">
                <div className="flex-shrink-0">
                  <span className={`bg-${patient.color}`} />
                </div>
                <div className="flex-grow-1">
                  <H6>{patient.lastname}</H6>
                </div>
              </div>
            </td>
            <td> {patient.address}</td>
            <td> {patient.email}</td>
            <td> {patient.phonenumber}</td>
            <td><Badge className="text-capitalize" color={`${patient.type === "adult" ? "primary" : "secondary"}`}>{patient.type}</Badge></td>
            <td>{patient.school}</td>
            <td>{patient.teacher_email}</td>
            <td>{patient.gp_email}</td>
          </tr>
        )) :
          <tr>
            <td colSpan={11} className="text-center">
              <div className="px-3 py-3">
                <span style={{ fontSize: 16 }}>No patients at the moment</span>
              </div>
            </td>
          </tr>}
      </tbody>
    </Fragment>
  );
};

export default PatientsTableBody;
